export default "__VITE_ASSET__9eacb4c6__"